import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enUs from "./locales/en-us.json";
import esUs from "./locales/es-us.json";
/* import enIn from "./locales/en-in.json"; */
import hiIn from "./locales/hi-in.json";
import frFr from "./locales/fr-fr.json";
import mrIn from "./locales/mr-in.json";

/**
 *  **important** The resources schema have keys without country - 'en' instead of 'en-us'
 */
const resources = {
  en: {
    translation: enUs,
  },
  es: {
    translation: esUs,
  },
  hi: {
    translation: hiIn,
  },
  fr: {
    translation: frFr,
  },
  mr: {
    translation: mrIn,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: "locale-streakspark",
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
